import { z } from "zod";

export const itemSchema = z.object({
	name: z.string().trim().min(1, "Informe o nome do item"),
	description: z.string().optional(),
	parentId: z.string().optional(),
	kind: z.enum(["stage", "substage", "service"]),
});

export type ItemFormValues = z.infer<typeof itemSchema>;
